<template>

  <div class="g-wxbg g-minh100vh testing-detail" 
  style="position:relative;">
<div class="top1"  >

    <van-icon name="arrow-left" class='top_left1' size='.2rem' @click='xcxtz()'/>

    <p >{{  data.title}}
    </p>
   
</div>

<div class="top2" v-if="jilu">
    <p>
您最近有新测评订单~
</p>
<button @click="tz5()">立即查看</button>
</div>


   <div class="cnt">
    <!---->
    <div class="g-white-bg g-plr10 detailcnt">
     <!---->
    
  

<div class="topfix" v-if="pt=='wx1' && in_arr==0">
    <p>
    <b>立即</b> 
    <span class="zq"> 分享好友 </span>
    
   每单立赚丰厚收益，上不封顶！
&nbsp;
    <span class="fxbtn" @click="fx"> 点击分享 </span>
    </p>
</div>


     <div    v-bind:class="(pt=='wx')?'detail-cnt-desc pt40':'detail-cnt-desc'" v-html="data.content">

     </div>



     <div class="mustknow" style="display:none;">
      <span class="g-inset-line">测试</span>需知 
     </div>




     <div style="display:none;" class="detail-mustknow-desc" v-html='data.xz'> 
      
     </div>



    </div>
    <!---->
    <p style="margin-top:.2rem;text-align: center;" v-if="shfx!=undefined">本产品为虚拟服务，使用完成后不予退款</p>
   </div>
   <div class="imm-testing-btn" v-if="data">





  <div  class="detail-footerNav detail-footerNav_bg">
   <!----> 
   <ul class="">
    <li 
     @click='zt("/")'
    class="detail-footerNav-one detail-footerNav-one1" style="touch-action: manipulation; user-select: none; -webkit-user-drag: none; -webkit-tap-highlight-color: rgba(0, 0, 0, 0);">
        <router-link to="/" >
            <van-icon name="wap-home-o"  size=".25rem"  />
 <span>   首页</span>
        </router-link>
        </li> 
    <li
      @click='zt("/list")'
    class="detail-footerNav-one detail-footerNav-one1" style="touch-action: manipulation; user-select: none; -webkit-user-drag: none; -webkit-tap-highlight-color: rgba(0, 0, 0, 0);">
           <router-link to="/list" >
 <van-icon name="apps-o"  size=".25rem"  />
 <span> 分类</span>
             </router-link>
        </li> 


<!--

-->

  <li 
 v-if="pt=='wx'"
      @click='zs()'
    class="detail-footerNav-one detail-footerNav-one1" style="touch-action: manipulation; user-select: none; -webkit-user-drag: none; -webkit-tap-highlight-color: rgba(0, 0, 0, 0);">
           <a >
 <van-icon name="gift-o" size=".25rem" color="#e92a2a"  />
 <span style="color:#e92a2a;"> 赠送</span>
             </a>
        </li> 


    <li 
    @click='fmzt(data.link)'
     v-bind:class="{ wx:pt=='wx'}"
 class="detail-footerNav-one detail-footerNav-buy" style="touch-action: manipulation; user-select: none; -webkit-user-drag: none; -webkit-tap-highlight-color: rgba(0, 0, 0, 0);">

       <a     @click='fmzt(data.link)'>
    <span class="btn-text">立即测试</span>
  </a>



     </li>
   </ul> 
   <!---->
  </div>



<!--
  <div class="deleteTip pubsontext" v-show="tipshow">
	      <div class="tipSon tipSon1">
	        <p>请留步，耐心完成本次测试有助于了解且提升自己，让你在生活和工作中得心应手。可以从报告中获得分析建议和提升建议。</p>
	        <div class="footerBut footerBut1">
               <span class="sure"   @click="tipColse">留下</span>
	          <span class="cancle" @click="tipBacks">离开</span>
	    
	        </div>
	      </div>
  </div>
-->


<!--
<router-link :to="data.link" style="color:#fff;" v-if="data.link!=undefined">

    <div class="imm-testing-btn__text">
     立即测试
    </div>
</router-link>

-->
<!--
<a :href="data.link" style="color:#fff;">

    <div class="imm-testing-btn__text">
     立即测试
    </div>
</a>
-->

   </div>
 

 <bq></bq>




<van-popup v-model="zs_show" position="bottom" :style="{ height: '66%' }"  round >
<div class="bt" style="color:#e92a2a">特别的礼物送给特别的朋友</div>
<ul class="zs">
    <li class="zsbt">
        <div class="z">测试标题</div>
        <div class="y" style="color:#333;">{{ data.catname }}</div>
    </li>
    <li class="zssl">
        <div class="z">赠送数量</div>
        <div class="y">
<span @click="jian()"><van-icon name="minus" /></span>
<span>{{ num }}</span>
<span @click="jia()"><van-icon name="plus" /></span>
        </div>
    </li>
    <li class="num">
<b @click="buy_num(1)" v-bind:class="{ active: num==1 }">1</b> 
<b @click="buy_num(2)"  v-bind:class="{ active: num>=2 &&num<5 }">2 <label >9.5折</label ></b> 
<b @click="buy_num(5)" v-bind:class="{ active: num>=5 &&num<10 }">5 <label >9折</label ></b> 
<b @click="buy_num(10)" v-bind:class="{ active: num>=10 &&num<20 }">10 <label >8折</label ></b> 
<b @click="buy_num(20)" v-bind:class="{ active: num>=20 &&num<50 }">20 <label >7折</label ></b> 
<!--
<b @click="buy_num(50)" v-bind:class="{ active: num>=50}">50 <label >6折</label ></b>
-->
    </li>
    <li class="zsjg">
        <div class="z">价格总计</div>
        <div class="y">{{ price }}元</div>
    </li>
    <li class="ts">
        <div class="z">温馨提示</div>
        <div class="y">赠送管理</div>
    </li>
</ul>

<p class="zssm">尊敬的用户，您可以直接单独购买此测试赠送给好友，可购买多份赠
予不同好友，购买成功后不予退款。</p>
<button class="zspay" @click="zsbuy()">帮好友支付</button>

</van-popup>


<div class="deleteTip pubsontext" v-show="tipshow">
    <div class="tipSon tipSon1">
<div class="right"><a :href="openlink"><van-icon name="cross" /></a> </div>
       

<div class="d_bt">微信公众号免费测~</div>

<div  class="wx-dialog-desc" style="padding:0px .2rem;
text-align:left;line-height: .27rem;font-size:.16rem; ">
        扫码进入【<span data-v-3ba6907c="" style="font-size: .18rem; font-weight: bold;">心知方</span>】<span data-v-3ba6907c="" style="color: rgb(35, 172, 56);">微信公众号</span><br>
        全部测评<span data-v-3ba6907c="" style="font-size: .16rem; font-weight: bold; color: rgb(255, 109, 101);">免费测</span>！
      </div>

<div class="ewm11">
    <img style="max-width: 100%;" src="https://wap.51lihaoedu.top/public/ewm11.jpg" alt="">
</div>
<!--
<ul>
    <li><a :href="openlink">
    <img src="https://adm56.51lihaoedu.top/uploads/20220708/6dc893b3ab3508c6663042b04a7d6bf4.jpg" alt="">
<div>你的城府有多深？</div>    
<button>前往测试</button>
</a></li>
<li><a :href="openlink">
    <img src="https://adm56.51lihaoedu.top/uploads/20220831/98d9e3eed1389b624c137ce6708bdcd1.png" alt="">
    <div>大脑也有性别？</div>    
<button>前往测试</button>
</a></li>
<li><a :href="openlink">
    <img src="https://adm56.51lihaoedu.top/back/uploads/20220101/b6fe60f7c241834fa9a3e7ca9619edb1.jpg" alt="">
    <div>你的情商有多高？</div>    
<button>前往测试</button>
</a></li>
<li><a :href="openlink">
    <img src="https://adm56.51lihaoedu.top/uploads/20220611/6958f51dc2f1d42a485ddb103024d700.png" alt="">
    <div>你是隐性天才吗？</div>     
<button>前往测试</button>
</a></li>

<li><a :href="openlink">
    <img src="https://adm56.51lihaoedu.top/back/uploads/20211009/ebc4d2991ee82c8ef5b8f1eb3bff61db.jpg" alt="">
    <div>你是渣男收割机？</div>    
<button>前往测试</button>
</a></li>
<li><a :href="openlink">
    <img src="https://adm56.51lihaoedu.top/uploads/20220626/0b7c8b4b9ef19a3e351c5b2a25bc3157.jpg" alt="">
    <div>异性吸引力测试</div>     
<button>前往测试</button>
</a></li>

<li><a :href="openlink">
    <img src="https://adm56.51lihaoedu.top/back/uploads/20211222/c24753505cd6acf51fa06f71e894a7e9.png" alt="">
    <div>怕黑是害怕什么？</div>     
<button>前往测试</button>
</a></li>


<li><a :href="openlink">
    <img src="https://adm56.51lihaoedu.top/back/uploads/20211009/1218214a2a3ba57aa6e707880cfa1d0a.jpg" alt="">
    <div>你是啥动物化身？</div>     
<button>前往测试</button>
</a></li>

<p>~更多测试 点击下方按钮查看~</p>





</ul>

<div class="hd">往下滑动查看更多 <van-icon name="arrow-down" /></div>
-->
<a class="button1" :href="openlink">立即打开【心知方】公众号</a>

        <!--
	<a :href="openlink"><button>小程序</button></a> 
-->

</div>
  </div>

  <ycxf option="list"></ycxf>
  <div v-if='pt=="wx"'>
  <viptc ref='viptc' :mo=false ></viptc>
</div>




<div class="mbtiyc"  v-if="ycshow">
    <span href="" @click="tck">
<img src="/img/sh.png" alt="">
</span>
<a href="/user/fankui">
<img src="/img/kf.png?" alt="">
</a>
  </div>

<van-popup v-model="tcshow" class="tc1">
    <van-button round type="info" @click="likai('/user/fankui')"  color="#4caf50" block>未获得报告</van-button>

    <van-button round type="info" @click="likai('/user/ts')"  block>我要反馈</van-button>

</van-popup>





</div> 

</template>

<style  lang="less"  scoped>
.copyright {
    padding-bottom: .8rem;
}
  .tc1{width: 2.4rem;padding:.15rem .3rem; padding-bottom: 0;border-radius:.2rem;
.van-button{margin-bottom: 0.15rem;}
}
.mbtiyc{
    position: fixed;right:0px;bottom:1rem;
img{width: 0.27rem;}
a{display: block;margin-bottom: .2rem;}
span{display: block;margin-bottom: .2rem;}
}
.top1,.top2{display: none;}
@media screen and ( max-width:768px ) {
    .top1{display: flex;position: fixed;height: .39rem;line-height:.39rem;
        z-index: 1000;
        justify-content: center;background:#fff;width:100%;top:0px;border:1px solid #eee;
.top_left1{position: absolute;left:.1rem;top: 0.1rem;}
}
.testing-detail{margin-top: 0.35rem;}
.top2{display: flex;width:100%;color:#fff;line-height: .42rem;font-size: 0.14rem;
    justify-content: space-between;  z-index: 1000;
padding: 0px 20px;box-sizing: border-box;
    position: fixed;top:.4rem;height: 0.42rem;background: #f16251;
font-weight: bold;
button{border:0px;color:#333;height:.28rem;
line-height: .28rem;border-radius: 20px;width: 1rem;margin-top: 0.07rem;
font-weight: bold;box-shadow: 0px 5px 5px -5px rgba(0,0,0,0.54);
-webkit-box-shadow: 0px 5px 5px -5px rgba(0,0,0,0.54);
-moz-box-shadow: 0px 5px 5px -5px rgba(0,0,0,0.54);
background-image: linear-gradient(#f6e6c5, #ebbf6e);
}

}


}





.tipSon{
    a{color:#333;}
    .right{display: flex;
    flex-direction: row-reverse;}
ul{height: 2.5rem;overflow: hidden;justify-content: center;
overflow-y: visible;display: flex;flex-wrap: wrap;
li{
    width: 38%;
    margin-bottom: 0.18rem;
    margin-right: 10px;
    border: 1px solid #f3f3f3;
    padding: 10px;box-shadow: 1px 7px 8px -6px rgba(0,0,0,0.15);
-webkit-box-shadow: 1px 7px 8px -6px rgba(0,0,0,0.15);
-moz-box-shadow: 1px 7px 8px -6px rgba(0,0,0,0.15);
    background: #f3f3f3;
    margin-bottom: 0.18rem;margin-right: 10px;
    img{width: 90%;border-radius: 10px;height:.85rem}
}
div{    font-size: .13rem;
    height: .25rem;
    line-height: .25rem;
    font-weight: 700;}
button{
margin-top: .05rem;
    padding: .06rem .2rem;
    background: #7da8f6;
    color: #fff;
    border-radius: .2rem;
    box-shadow: 0.01rem 0.01rem 0.07rem #7ea9f5;border:0px;
}

}
.hd{margin-top: 0.17rem;}
.d_bt{font-size: 0.2rem;margin-bottom: 0.1rem;font-weight: bold;}
.button1{
   width: 90%;border:1px solid #1ea967;display: block;
  margin:0px auto;padding: .08rem 5px;color:rgb(7, 193, 96);border-radius: .5rem;
margin-top: 0rem;font-size: 0.16rem;margin-bottom: 0.1rem;
}
}

.bt{text-align: center;font-weight: bold;font-size: 0.18rem;color:#333;margin-top: 0.15rem;margin-bottom: 0rem;}
.zs{
padding: 0.15rem;padding-bottom: 0px;
    li{display: flex;justify-content: space-between;
    margin-bottom: 0.1rem;height: 0.35rem;align-items: center;
    .z{width:1rem;border-left:5px solid #e92a2a;padding-left: 0.08rem;
    font-size: 0.16rem;height: .2rem;line-height: .2rem;
    }
    }

.zsbt .y{color:#e92a2a;font-size: 0.16rem;position: relative;top:-.04rem;font-weight: bold;}
.zssl{overflow: hidden;}
.zssl .y{
    display: flex;justify-content: center; 
    span{width:.3rem;height:.28rem;font-size: 0.16rem;background: #eee;
    text-align: center;line-height: .3rem;margin-right: .03rem;border-radius: .05rem;}
}


.zsjg .y{color:#e92a2a;font-size: 0.18rem;font-weight: bold;}

}
.ts .y{color:#e92a2a;}
.zssm{padding:0rem .18rem;color:#999;font-size: 0.12rem;line-height: 0.2rem;}

.zspay{border:0px;background: #e92a2a;color:#fff;width:85%;height:.4rem;margin:0px auto;display: block;border-radius: .3rem;font-size: 0.18rem;margin-top: 0.15rem;}

.zs .num{display: flex;flex-wrap: wrap;height: auto;  justify-content: flex-start;
b{width: 0.79rem;background: #fff;color:#333;margin-bottom: 0.1rem;
border:1px solid #eee;height:.3rem;  text-align: center;margin-right: .05rem;
line-height: .3rem;border-radius: .04rem;position: relative;
}
}
.zs .num label {position: absolute;font-size: .09rem;width:.3rem;right:.01rem;
top:-.05rem;color:#e92a2a;text-align: right;}


.zs  .num .active{background:#efefef;color:#e92a2a;}
</style>


<script>
import Vue from 'vue';
import Bq from './../Bq.vue';
import global from './../common.vue'
import viptc from './../../components/ans_viptc';
import { Icon } from 'vant';
import { Dialog } from 'vant';
Vue.use(Icon);
import { Popup } from 'vant';
import { Toast } from 'vant';
import ycxf from '../../components/part/ycxf';
import { Button } from 'vant';
Vue.use(Button);
Vue.use(Toast);
Vue.use(Popup);
Vue.use(Dialog);
export default {
        name: 'Detail',
         components:{
   Bq,ycxf,viptc
    },
        data() {
            return {
                   
                     data:[],
                     tz:0,
                 tipshow:false,//控制提示弹窗显隐
			backStatu: false,//判断当执行页面回退时是否要执行next(true)
                     id:'',
                         backConfirm: true,
                        zs_show:false, 
                        num:1,
                      price:0,
                      zhe:1,
                      shfx:localStorage.getItem('shfx'),
        bool:true,
        host:null,
        openlink:null,
        in_arr:null,
        jilu:false,
        jilu_id:null,
        ycshow:false,
          tcshow:false,
        name:''
            }
        },
     
        created() {
            if(this.$route.query.shfx!=undefined){
  localStorage.setItem('shfx',this.$route.query.shfx);
}
            localStorage.removeItem('choose');
/*
               var vConsole = new VConsole();
*/

//localStorage.setItem('choose',this.$route.query.choose);


let currentDomain = window.location.hostname;


if (currentDomain.includes("jrtt")) {
   this.ycshow=true;
} 




if(this.$route.query.cho!=undefined){
    localStorage.setItem('cho',this.$route.query.cho);
 }else{
    localStorage.removeItem('cho');
 }

var url=window.location.href;


if (url.includes('openid')) {
  
}else{
localStorage.setItem('url',url);
}


        this.host=window.location.host;
    
if(this.$route.query.fxid!=null){

localStorage.setItem('fxid',this.$route.query.fxid);
localStorage.setItem('fxcat',this.$route.query.id);
}
if(this.$route.query.temp!=null){
localStorage.setItem('temp',this.$route.query.temp);
}else{
    localStorage.removeItem('temp');
}



if(this.$route.query.zscode!=null){
localStorage.setItem('zscode',this.$route.query.zscode);

}

if(this.$route.query.show==1){
    this.zs_show=1;
}


if(this.$route.query.id==null || this.$route.query.id==''  || this.$route.query.id==undefined){
     window.location.href="/";
}
document.body.scrollTop = document.documentElement.scrollTop = 0;


 //判断浏览器
  var system = { 
   win: false, 
   mac: false, 
   xll: false, 
   ipad: false
  }; 
  //检测平台 
  var p = navigator.platform; 
  system.win = p.indexOf("Win") == 0; 
  system.mac = p.indexOf("Mac") == 0; 
  system.x11 = (p == "X11") || (p.indexOf("Linux") == 0); 
  system.ipad = (navigator.userAgent.match(/iPad/i) != null) ? true : false; 
  //跳转语句，如果是手机访问就自动跳转到wap.baidu.com页面 

  if (system.win || system.mac || system.xll || system.ipad) { 
//alert("在PC端上打开的");
 this.pt='pc'
  } else { 
   var ua = navigator.userAgent.toLowerCase(); 
   if(ua.match(/MicroMessenger/i)=="micromessenger") { 
 //alert("在手机端微信上打开的"); 
  this.pt='wx'
   } else { 
  // alert("在手机上非微信上打开的"); 
     this.pt='wap'
   } 
  }
//结束判断

console.log(global.ym_arr.indexOf(window.location.host,0));
if(global.ym_arr.indexOf(window.location.host,0)==-1){
   this.in_arr=0;
}else{
    this.in_arr=1;
 
}

console.log(this.in_arr);





      












    //公众号获取openid
   if(this.pt=='wx'){
      
  

if(this.in_arr==0){


var openidcode=this.$route.query.openidcode;
var uid=this.$route.query.uid;

var id=this.$route.query.id;

if(openidcode==undefined){
     var openid=localStorage.getItem('openid');

      if(openid==undefined){
if(this.$route.query.shfx==null || this.$route.query.shfx==undefined){
window.location.href=global.http+"/api/login?url=detail&id="+id+"&host="+this.host;
}else{
 if(localStorage.getItem('shfx')!=undefined){
    window.location.href=global.http+"/api/login?url=detail&id="+id+"&host="+this.host+"&shfx="+localStorage.getItem('shfx');

 }else{
    window.location.href=global.http+"/api/login?url=detail&id="+id+"&host="+this.host+"&shfx="+this.$route.query.shfx;
 }
}
      }
}else{
    console.log(openidcode)
    localStorage.setItem('openid',openidcode);
    localStorage.setItem('uid',uid);
    this.$router.push('/test/detail?id='+id);
}
}

}



          var that=this;
          that.id=that.$route.query.id;
         
        this.$axios.get(global.http+'/api/detail'
        ,{
        params:{
         id:that.id,
         r:document.referrer
        }
        }
        ).then(
            (response) => {
    that.data=response.data;
    that.price=response.data.price;
    document.title = that.data.title;
    that.name= that.data.sys.name;
that.jilu_id=this.data.link.split('=')[1].replace(/[^0-9]/g,'');
console.log(that.jilu_id);
if(that.pt=='wap'){
if(localStorage.getItem('o'+that.jilu_id)!=null){
   that.jilu=true;
}
}

 that.fkmb();

if(this.$route.query.tz==1){
    this.$router.push(response.data.link);
}




    }
    ).catch((e) => {



    //     window.location.href="http://wap.51lihaoedu.top/test/detail?id="+id;
        })
      




/*

	var htmlUrl = location.href.split('#')[0];



  this.$axios.get(global.http+'/fx/test'
        ,{
       
        }
        ).then(
            (res) => {
   
     wx.config({
                debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                appId: res.data.appId, // 必填，公众号的唯一标识
                timestamp: res.data.timestamp, // 必填，生成签名的时间戳
                nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
                signature: res.data.signature, // 必填，签名，见附录1
                jsApiList: ["updateAppMessageShareData","updateTimelineShareData"] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
            });
      
    }).catch((e) => {
    //     window.location.href="http://wap.51lihaoedu.top/test/detail?id="+id;
        })
            */






if( this.pt=='wx'){



}else{

window.history.pushState('forward', null,'#');
window.history.forward();
window.onpopstate = function(event) {
//window.parent.plfCloseFrameSearchWindow();//监听回退按钮进行相关操作
//that.tipshow=true;

that.xcxtz();


}



}






        }
        ,methods: {  likai(val){
                location.href=val;
            }
            ,tck(){
                this.tcshow=true
            },
            fkmb:function(){
            

var host1=window.location.host;


if(this.pt=='wap' || this.pt=='wx' || this.pt=='pc'){

if(this.data.choose!='' && this.data.choose!=null){


let arr=this.data.choose.split("\n");
arr.forEach((val,index)=>{
var arr1=val.split('|')
if(host1==arr1[0]){
    localStorage.setItem('choose',arr1[1]);
}else{
    if(this.$route.query.choose!=undefined){
    localStorage.setItem('choose',this.$route.query.choose);
 }

}

})

    
}else{

 if(this.$route.query.choose!=undefined){
    localStorage.setItem('choose',this.$route.query.choose);
 }else{
    localStorage.removeItem('choose');
 }

}




}  

},
        xcxtz:function(){
/*
            let that=this;
if(that.pt=='wx'){
    this.$router.push('/list');

}else{

            this.$axios.post(global.http+'/xcx/xzf',{
              host:window.location.href
            }).then((res) => {
if(res.data.errmsg=='ok'){

    that.tipshow=true;
that.openlink=res.data.openlink;
setTimeout(function(){
    window.location.href=res.data.openlink;
}, 2000 )




//that.wxlj=res.data.url_link;
}
  }
  )

}
*/
let that=this;
if(that.pt=='wx'){
    this.$router.push('/list');

}else{

if(localStorage.getItem('shfx')!=undefined || localStorage.getItem('shfx')!='' ){
    this.$router.push('/list');
}else{
 
location.href=global.fmht;
}


}

        },tz5:function(){
        //    this.$router.push('/test/chadan?cat='+this.id);


      
location.href='/test/chadan?oid='+localStorage.getItem('o'+this.jilu_id);




        },
fx:function(){
    this.$router.push('/fx/hb?cat='+this.id);

  
},zs:function(){
this.zs_show=true;
},



            fmzt:function(val){
                 this.$router.push(val);
            },
             logout:function(){
         localStorage.removeItem("openid");
     }
,tipColse() {
 
this.tipshow = !this.tipshow;
 
},
			tipBacks() {
				this.backStatu = true;
			 window.location=global.xfht;
			},
            jia(){
this.num++;
            },jian(){
if(this.num>1){
    this.num--;
}
            },


            //赠送管理
buy_num:function(num){
this.num=num;
},

            zsbuy:function(){
    let that=this;
const tip1=Toast.loading({
  message: '提交中...',
  forbidClick: true,
  duration:0
});
this.$axios.post(global.http+'/zs/buy',
{openid:localStorage.getItem('openid'),num:that.num,cid:that.data.id}
        ).then(
            (res) => {
 if(res.data.code==1){
       tip1.clear();
     that.pay(res.data.zs_id);
 }
   
    }
    )  

},pay:function(zs_id){
  const tip2=Toast.loading({
  message: '等待支付中...',
  forbidClick: true,
  duration:0
});

   var that=this;
        this.$axios.get(global.http+'/zs/wxzf?zs_id='+zs_id+'&openid='+localStorage.getItem('openid')).then((response) => {
             tip2.clear();
   that.zf=response.data;


     WeixinJSBridge.invoke(
       'getBrandWCPayRequest',that.zf,
       function(res){
           if(res.err_msg == "get_brand_wcpay_request:ok" ) {
 

  

Toast({
type:'success',
message: '支付成功',
  forbidClick: true,
  duration:1000,
  onClose:function(){
      location.href="/zs/list"
  }
});

           }
       }
   );



    })

}












        },watch:{
num:{
handler: function (val) { 

if(val>=2 &&val<5){
    this.zhe=0.95;
}

if(val>=5 &&val<10){
    this.zhe=0.9;
}

if(val>=10 &&val<20){
    this.zhe=0.8;
}
if(val>=20 &&val<50){
    this.zhe=0.7;
}
if(val>=50){
    this.zhe=0.6;
}

   this.price=(this.data.price*this.num*this.zhe).toFixed(1);

   

 },
      deep: true
     } 
        }
       /*
   
        ,beforeRouteLeave (to, from, next) {
     console.log(to.path);
     console.log(from.path);
if(this.backStatu){
		    	next(true);
}else{
 
				next(false);
			}


			this.tipshow = true;




    }
*/



}
</script>


<style  lang="less"  scoped>

.pt40{padding-top: 0rem;}

</style>



<style>

.topfix{position: fixed;background: #fff;height: 0.4rem;width: 100%;
z-index: 1000;line-height: 0.48rem;text-align: center;
box-shadow: 0px 8px 18px -1px rgba(200,200,200,0.63);
-webkit-box-shadow: 0px 8px 18px -1px rgba(200,200,200,0.63);
-moz-box-shadow: 0px 8px 18px -1px rgba(200,200,200,0.63);
}
.topfix .zq{border:1px solid #f14848;
color:#f14848;padding: .02rem;height: 0.23rem;line-height: .2rem;box-sizing: border-box;
display:inline-block;margin: 0px .03rem;
}
.topfix .fxbtn{background: #f14848;color:#fff;padding:.03rem;
font-size: 0.12rem;border-radius: 0.05rem;padding:0.04rem;}




.detail-cnt-desc{margin-top: 0rem;}

.detail-footerNav_bg ul {
    background: #fff;
}
.detail-footerNav ul {
    max-width: 5.4rem;
    height: .5rem;
    position: fixed;
    z-index: 7;
    
            margin: auto;
            bottom: 0; /*底部固定*/
            left: 0; /*实现div的居中*/
            right: 0; /*实现div的居中*/
    display: flex;
    justify-content: space-between;
    box-shadow: 0 -3px 6px 0 rgb(0 0 0 / 7%);
padding-bottom: env(safe-area-inset-bottom);
padding-bottom: constant(safe-area-inset-bottom); 
 


}

.detail-footerNav .detail-footerNav-one {
    flex: auto;
    font-size: 12px;
    color: #999;
    line-height: 1.1;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 1rem;
}

.detail-footerNav .detail-footerNav-one a{
   
    color:#444;
}
.detail-footerNav .detail-footerNav-one .my-icon{
   display: block;
}
.detail-footerNav .detail-footerNav-one {
    flex: auto;
    font-size: 12px;
    color: #999;
    line-height: 1.1;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 1.2rem;
}

.detail-footerNav-one1 span{display: block;margin-top: 0.02rem;}
.detail-footerNav .detail-footerNav-one1  a{
   
   font-size: 0.14rem;
}



.detail-footerNav .detail-footerNav-one i.mine.not-login {
    background: url('/images/liebiao.png');
    background-size: cover;
  width:.26rem;
    height: .4rem;position: relative;top:.02rem;
    display: inline-block;
}

.detail-footerNav .detail-footerNav-buy {
    min-width: 2.7rem;
    background-image: linear-gradient(-225deg,#e92a2a,#f14848);
    font-size: .18rem;
    color: #613e1f;
    text-align: center;
    line-height: 1.18667rem;
    font-weight: 700;
}

.detail-footerNav  .wx {
    min-width: 2.2rem;

}

  @media only screen and (min-width: 1024px){
    .detail-footerNav .detail-footerNav-buy {
    min-width: 4rem;}


.detail-footerNav .detail-footerNav-one i.mine.not-login {

  width:.26rem;
    height: .42rem;
}






  }
.detail-footerNav .detail-footerNav-buy a{
    -webkit-animation: gotest-data 1.1s infinite;    color: #fff;
    animation: gotest-data 1.1s infinite;}

    .g-minh100vh {
    min-height: 100vh;
}
.g-wxbg {
    background-color: #ededed;
}
.testing-detail .cnt .detailcnt {
    padding-bottom: .15rem;
    overflow-x: hidden;
}
.g-plr10 {
    padding: 0 .1rem;
}
.g-white-bg {
    background-color: #fff;
}
.testing-detail .cnt .detailcnt .detail-cnt-desc {
    font-size: .14rem;
}
.testing-detail .cnt .detailcnt .mustknow, .testing-detail .cnt .detailcnt .title {
    padding: .2rem 0;
    font-size: .18rem;
}
.g-inset-line {
    box-shadow: inset 0 -0.06rem #f8bf54;
}
.testing-detail .cnt .detailcnt .detail-cnt-desc img {
    max-width: 100%;
    object-fit: contain;
}

/*
.testing-detail .imm-testing-btn {
    position: fixed;
    bottom: 0.2rem;
   left: 0%;
    right: 0;
    width: 243px;
    margin: 0 auto;
    text-align: center;
    padding: .15rem .4rem;
    color: #fff;
    font-size: .16rem;
    background: #e54d42;
    cursor: pointer;
    z-index: 9999;
    border-radius: 8px;
}
*/

.testing-detail .imm-testing-btn__text {
    -webkit-animation: gotest-data 1.1s infinite;
    animation: gotest-data 1.1s infinite;
}
.g-plr10 {
    padding: 0rem;
}
p{padding: 0px;margin: 0px;}
.detail-cnt-desc img{display: block;width: 100%;}
.testing-detail .cnt .detailcnt {
    padding-bottom: 0rem;
    overflow-x: hidden;
}
body {
    padding-bottom: 0rem;
}

.copyright {margin: 0.2rem 0 0rem;padding-bottom:1rem;}
body {
    padding-bottom: 0rem;
}



.deleteTip {
    height: 100%;
    width: 100%;
    position: fixed;
    background: rgba(0, 0, 0, 0.5);
  top:0px;left:0px;
    z-index: 4;
}
.pubsontext .tipSon {
    top: 50%;
}
.deleteTip .tipSon {
    text-align: center;
    position: absolute;
    left: 50%;
    transform: translate(-50%, -50%);
    margin: auto 0;
    width:2.8rem;
    background: #fff;
    border-radius: 0.1rem;z-index: 10000;
    padding: .15rem 0.15rem;
}
.pubsontext .tipSon p {
    text-align: center;
    font-size: 0.3rem;

}
.deleteTip .tipSon p {
    color: #000000;

       padding-bottom: 0.2rem;
    padding-top: 0.07rem;
    font-size: 0.16rem;
}
.deleteTip .tipSon .footerBut {
   

    color: #666;
}

.deleteTip .tipSon .footerBut .cancle, .deleteTip .tipSon .footerBut .sure {
  
   
    display: block;
    height: .40rem;
    line-height: .40rem;
    margin-top: 0.05rem;
    box-sizing: border-box;
    color: #FFFFFF;
    background-color: rgb(7, 193, 96);
    border-radius: 0.03rem;
    font-size: .16rem;
    border:1px solid #ddd;

}



.deleteTip .tipSon .footerBut .cancle {
 background: #fff;
    color: #999;margin-top: .1rem;cursor: pointer;

}
.deleteTip .tipSon .footerBut .sure {
    color: #fff;
       border:1px solid rgb(7, 193, 96);cursor: pointer;
  
}




.deleteTip .tipSon1 p{
    font-size: .14rem;
    padding-top: 0rem;line-height: .3rem;
        padding-bottom: 0.1rem;
}

.deleteTip .tipSon .footerBut1{display:flex;justify-content: center;}

.deleteTip .tipSon .footerBut1 span {
   width:30%;margin-left: 0.1rem !important;
}
.deleteTip .tipSon .footerBut1 .cancle {
    background: #fff;
    color: #999;
    margin-top: 0rem;
    cursor: pointer;
}


.deleteTip .tipSon .footerBut1 .sure {
     margin-top: 0rem;
}





@-webkit-keyframes gotest-data {
	0% {
		-webkit-transform: scale(1);
		transform: scale(1)
	}

	50% {
		-webkit-transform: scale(1.2);
		transform: scale(1.2)
	}

	to {
		-webkit-transform: scale(1);
		transform: scale(1)
	}
}

</style>